import axios from "axios";
import { LandingTitle, Loader, PageLayout } from "../../components/index";
import { baseUrl, getAmenitiesPage } from "../../utils/apiData";
import { images } from "../../utils/images";
import ImageGallery from "./imageGallery/ImageGallery";
import { useState, useEffect, Fragment } from "react";
import {Helmet} from "react-helmet";

const Amenites = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  // Page API Start
  const getGalleryApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getAmenitiesPage}`);
      if (res?.data?.success) {
        setData(res?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  // Page API End

  useEffect(() => {
    getGalleryApi();
  }, []);

  return (
    <PageLayout>
         <Helmet>
        <title>Amenities | Exotic Group</title>
        <meta name="description" content="Amenities | Exotic Group" />
      </Helmet>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <LandingTitle
            bgImage={images.galleryLanding}
            title="Our Amenities "
            para="Explore a glimpse of luxury living with our carefully designed spaces, premium interiors, and breathtaking views. Every detail reflects sophistication, comfort, and exclusivity."
          />
          <ImageGallery dataList={data} />
        </Fragment>
      )}
    </PageLayout>
  );
};

export default Amenites;
